module.exports = new __parcel__URL__("battlepass_previous_page_button_active.58c0c7c1.png").toString();